export default "__VITE_ASSET__0309cd6d__"